/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type StorefrontProductTile_product$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type StorefrontProductGrid_products$ref: FragmentReference;
export type StorefrontProductGrid_products = {|
  +edges: ?$ReadOnlyArray<?{|
    +node: ?{|
      +serviceId: ?string,
      +categoryPath: ?string,
      +categoryCode: ?string,
      +ecommerceTrackingParams: ?any,
      +$fragmentRefs: StorefrontProductTile_product$ref,
    |}
  |}>,
  +$refType: StorefrontProductGrid_products$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "StorefrontProductGrid_products",
  "type": "DealerStorefrontQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "DealerStorefrontQueryEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Item",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "serviceId",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "categoryPath",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "categoryCode",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "ecommerceTrackingParams",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "FragmentSpread",
              "name": "StorefrontProductTile_product",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '7f0a0a6d19b0517fc1d43c36783d7e8e';
module.exports = node;
